const headNav = {
    namespaced: true,
    state: {
        navActive: '首页'
    },
    mutations: {
        updataNavActive (state, data) {
            state.navActive = data
        }
    }
}

export default headNav


// WEBPACK FOOTER //
// ./src/store/modules/headNav.js